import { Box, SxProps, Typography } from '@mui/material'
import { Image } from '@media-components'
import { CustomStyles, getStyles } from '@utils/styles'
import { CardData } from '../DefaultCard'
import defaultStyles, { StyleClassNames } from './styles'

export type StatsCardData = CardData

export type StatsCardProps = StatsCardData & {
  csx?: CustomStyles<StyleClassNames>
  darkBg?: boolean
  idx?: number
  sx?: SxProps
}

export function StatsCard({
  title,
  description,
  iconData,
  imageData,
  idx = 0,
  csx,
  darkBg = false,
  sx,
}: StatsCardProps) {
  const styles = getStyles(defaultStyles, csx)
  const image = iconData ?? imageData
  return (
    <Box
      {...styles('wrapper', {
        flexBasis: {
          xs: 'calc(100% - 16px)',
          sm: 'calc(50% - 16px)',
          md:
            // eslint-disable-next-line no-nested-ternary
            idx < 3 ? '32%' : idx < 5 ? '49%' : '32%',
        },
        backgroundColor: darkBg ? 'custom.lightGrey' : 'background.paper',
        boxShadow: darkBg ? undefined : 2,
        ...sx,
      })}
    >
      <Box {...styles('titleWrapper')}>
        {image && (
          <Image {...image} width={48} height={48} {...styles('icon')} />
        )}
        <Typography
          variant="h5.500"
          color={darkBg ? 'text.primaryDark' : 'text.primary'}
        >
          {title}
        </Typography>
      </Box>
      {description && (
        <Typography
          variant="body2.400"
          color={darkBg ? 'text.primaryDark' : 'text.primary'}
        >
          {description}
        </Typography>
      )}
    </Box>
  )
}
